import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { IJobCandidateInteraction, getApplicationInsightsAgg } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import ApplicationByCandidate from './ApplicationByCandidate';
import ApplicationMetrics from './ApplicationMetrics';
import IApplicationInsights from './types/IApplicationInsights';

const ApplicationInsightsContainer = ({ query }: { query: IJobCandidateInteraction }) => {
  const [aggreagtion, setAggregation] = useState<IApplicationInsights>({
    data: [],
    metaData: { viewed: 0, acted: 0, total: 0 },
  });

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await getApplicationInsightsAgg(query);
      setAggregation(data);
    };
    fetchData();
  }, [query]);

  return (
    <Box p={2} bgcolor={WsColors.White} height={600}>
      <ApplicationMetrics agg={aggreagtion} />
      <br />
      <ApplicationByCandidate agg={aggreagtion} />
    </Box>
  );
};

export default ApplicationInsightsContainer;
